<template>
  <div class="country-icon">
    <img
      v-if="code"
      :alt="name"
      :src="require('@/assets/' + code + '.png')"
      :style="{ height: '23px', width: '28px', transform: 'rotate(17deg)', marginTop: '3px' }">
  </div>
</template>

<script>
export default {
  props: {
    code: String,
    name: String,
    size: String
  }
}
</script>

<style scoped>
.country-icon { align-items: center; display: inline-flex; height: 30px; justify-content: center; width: 30px; }
img { text-indent: -999px; }
</style>



// WEBPACK FOOTER //
// src/components/icons/CountryIconNew.vue